import { render, staticRenderFns } from "./formalProjectOrder.vue?vue&type=template&id=6550e12c&scoped=true"
import script from "./formalProjectOrder.vue?vue&type=script&lang=js"
export * from "./formalProjectOrder.vue?vue&type=script&lang=js"
import style0 from "./formalProjectOrder.vue?vue&type=style&index=0&id=6550e12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550e12c",
  null
  
)

export default component.exports